import { Role } from "../../../domain/Role";
import { IOrganizationProductInstance, OrganizationProduct } from "../../../domain/OrganizationProduct";
import { Dropdown } from "@optimizely/axiom";
import { ALL } from "../../../constants/constants";
import React from "react";

// TODO: Refactor GenericDropdownFilter to use a generic type parameter
// (e.g. <T extends { id: string; name?: string }>) instead of the
// GROUP_FILTER_TYPES union so it can be reused with additional entity
// types while preserving strong typing.
type GROUP_FILTER_TYPES =
    | OrganizationProduct
    | IOrganizationProductInstance
    | Role
    | { id: string; name: string }
    | null;
interface IGenericDropdownFilterProps {
    "data-cy"?: string;
    disabled?: boolean;
    hideAllOption?: boolean;
    label: string;
    onChange: ({ value }: { value: GROUP_FILTER_TYPES }) => void;
    options: (OrganizationProduct | IOrganizationProductInstance | Role | { id: string; name: string })[];
    value?: GROUP_FILTER_TYPES;
}

export const GenericDropdownFilter = ({
    "data-cy": dataCy,
    disabled,
    hideAllOption,
    label,
    onChange,
    options,
    value
}: IGenericDropdownFilterProps) => {
    return (
        <Dropdown
            data-cy={dataCy}
            buttonContent={{
                label: label,
                content: (value as IOrganizationProductInstance)?.nickname || value?.name || ALL
            }}
            isDisabled={disabled}
            style="plain"
            arrowIcon="down"
            width={350}
        >
            <Dropdown.Contents>
                {!hideAllOption && (
                    <Dropdown.ListItem role="option">
                        <Dropdown.BlockLink isLink={!!value} onClick={() => onChange({ value: null })}>
                            <Dropdown.BlockLinkText text="All" />
                        </Dropdown.BlockLink>
                    </Dropdown.ListItem>
                )}
                {options.map((option) => {
                    const { id, name } = option;
                    return (
                        <Dropdown.ListItem key={id} role="option">
                            <Dropdown.BlockLink isLink={value?.id !== id} onClick={() => onChange({ value: option })}>
                                <Dropdown.BlockLinkText
                                    text={(option as IOrganizationProductInstance)?.nickname || name}
                                />
                            </Dropdown.BlockLink>
                        </Dropdown.ListItem>
                    );
                })}
            </Dropdown.Contents>
        </Dropdown>
    );
};

GenericDropdownFilter.displayName = "GenericDropdownFilter";
